/**
 * SEO utility — sets document.title + all critical meta tags per page.
 * Works perfectly for Vue CLI SPAs (client-side rendering).
 */

const BASE = 'https://www.kebeeindustries.com'
const DEFAULT_IMAGE = `${BASE}/og-image.jpg`

function setMetaTag(attr, key, value) {
  if (!value) return
  let el = document.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', value)
}

function setCanonical(path) {
  const href = `${BASE}${path || '/'}`
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * @param {object} options
 * @param {string} options.title        — Full page title (appears in browser tab + Google)
 * @param {string} options.description  — Meta description (max ~160 chars)
 * @param {string} [options.path]       — URL path e.g. '/products/hdpe-tarpaulins'
 * @param {string} [options.image]      — Absolute URL to OG image
 * @param {string} [options.type]       — og:type, default 'website'
 * @param {string} [options.keywords]   — Comma-separated keywords
 */
export function setSeo({ title, description, path = '/', image, type = 'website', keywords }) {
  const url = `${BASE}${path}`
  const img = image || DEFAULT_IMAGE

  // Title
  document.title = title

  // Standard meta
  setMetaTag('name', 'description', description)
  if (keywords) setMetaTag('name', 'keywords', keywords)

  // Open Graph
  setMetaTag('property', 'og:title', title)
  setMetaTag('property', 'og:description', description)
  setMetaTag('property', 'og:url', url)
  setMetaTag('property', 'og:image', img)
  setMetaTag('property', 'og:type', type)
  setMetaTag('property', 'og:site_name', 'KeBee Industries')

  // Twitter
  setMetaTag('name', 'twitter:title', title)
  setMetaTag('name', 'twitter:description', description)
  setMetaTag('name', 'twitter:image', img)
  setMetaTag('name', 'twitter:card', 'summary_large_image')

  // Canonical
  setCanonical(path)
}
